const COPIED_RESET_MS = 1200;

const resetTimers = new WeakMap<HTMLElement, number>();

interface CopyFeedbackOptions {
  copiedLabel?: string;
  copiedText?: string;
  textSelector?: string;
}

function showCopiedFeedback(button: HTMLElement, options: CopyFeedbackOptions): void {
  const existingTimer = resetTimers.get(button);
  if (existingTimer !== undefined) {
    window.clearTimeout(existingTimer);
  }

  const textEl = options.textSelector
    ? button.querySelector<HTMLElement>(options.textSelector)
    : null;
  const prefixIcon = button.querySelector<HTMLElement>('sl-icon[slot="prefix"]');
  const previousName = button.getAttribute('name');
  const previousLabel = button.getAttribute('label');
  const previousText = textEl?.textContent ?? null;
  const previousPrefixIconName = prefixIcon?.getAttribute('name') ?? null;

  button.classList.add('copy-feedback', 'is-copied');
  if (previousName !== null) button.setAttribute('name', 'check2-circle');
  if (previousLabel !== null) {
    button.setAttribute('label', options.copiedLabel ?? 'Copied');
  }
  if (prefixIcon) prefixIcon.setAttribute('name', 'check2-circle');
  if (textEl && options.copiedText) textEl.textContent = options.copiedText;

  const resetTimer = window.setTimeout(() => {
    button.classList.remove('is-copied');
    if (previousName !== null) button.setAttribute('name', previousName);
    if (previousLabel !== null) button.setAttribute('label', previousLabel);
    if (prefixIcon && previousPrefixIconName !== null) {
      prefixIcon.setAttribute('name', previousPrefixIconName);
    }
    if (textEl && previousText !== null) textEl.textContent = previousText;
    resetTimers.delete(button);
  }, COPIED_RESET_MS);

  resetTimers.set(button, resetTimer);
}

export async function copyTextWithFeedback(
  text: string,
  button: HTMLElement,
  options: CopyFeedbackOptions = {},
): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    showCopiedFeedback(button, options);
  } catch {
    // Clipboard may be unavailable in insecure contexts; keep copy failures quiet.
  }
}
